import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var FormsReportService = /** @class */ (function () {
    function FormsReportService(apollo) {
        this.apollo = apollo;
    }
    FormsReportService.prototype.accountFormsAnswers = function (where, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var items;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo
                            .query({
                            query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          query accountFormsAnswers(\n            $where: DashboardFormsAnswersWhereInput!\n            $limit: Int!\n            $offset: Int!\n          ) {\n            accountFormsAnswers(where: $where limit: $limit offset: $offset) {\n            totalCount\n            items {\n              formId\n              formName\n              formAnswerCount\n            }\n        }\n      }"], ["\n          query accountFormsAnswers(\n            $where: DashboardFormsAnswersWhereInput!\n            $limit: Int!\n            $offset: Int!\n          ) {\n            accountFormsAnswers(where: $where limit: $limit offset: $offset) {\n            totalCount\n            items {\n              formId\n              formName\n              formAnswerCount\n            }\n        }\n      }"]))),
                            variables: {
                                where: where,
                                offset: options.offset,
                                limit: options.limit
                            }
                        })
                            .toPromise()
                            .then(function (result) { return result.data['accountFormsAnswers']; })];
                    case 1:
                        items = _a.sent();
                        return [2 /*return*/, items];
                }
            });
        });
    };
    FormsReportService.prototype.getFormById = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo
                            .query({
                            query: gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n          query getForm($id: ID!) {\n            form(id: $id) {\n              id\n              name\n            }\n          }\n        "], ["\n          query getForm($id: ID!) {\n            form(id: $id) {\n              id\n              name\n            }\n          }\n        "]))),
                            variables: {
                                id: id,
                            }
                        })
                            .toPromise()
                            .then(function (result) { return result.data['form']; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FormsReportService.prototype.accountFormsAnswersDetail = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo
                            .query({
                            query: gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n          query accountFormsAnswersDetail($where: DashboardFormsAnswersDetailWhereInput!) {\n            accountFormsAnswersDetail(where: $where) {\n              items {\n                title\n                type\n                position\n                answers {\n                  typeName: __typename\n                  ... on ClosedQuestionAnswerStatistics {\n                    value\n                    count\n                  }\n                  ... on OpenQuestionAnswerStatistics {\n                    value\n                  }\n                  ... on MultipleQuestionAnswerStatistics {\n                    values\n                  }\n                }\n              }\n            }\n          }"], ["\n          query accountFormsAnswersDetail($where: DashboardFormsAnswersDetailWhereInput!) {\n            accountFormsAnswersDetail(where: $where) {\n              items {\n                title\n                type\n                position\n                answers {\n                  typeName: __typename\n                  ... on ClosedQuestionAnswerStatistics {\n                    value\n                    count\n                  }\n                  ... on OpenQuestionAnswerStatistics {\n                    value\n                  }\n                  ... on MultipleQuestionAnswerStatistics {\n                    values\n                  }\n                }\n              }\n            }\n          }"]))),
                            variables: {
                                where: where
                            }
                        })
                            .toPromise()
                            .then(function (result) { return result.data['accountFormsAnswersDetail'].items; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FormsReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormsReportService_Factory() { return new FormsReportService(i0.ɵɵinject(i1.Apollo)); }, token: FormsReportService, providedIn: "root" });
    return FormsReportService;
}());
export { FormsReportService };
var templateObject_1, templateObject_2, templateObject_3;
